(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (!root) return;
    if (root.dataset.valmontiCarouselReady) {
      root.valmontiCarouselUpdate?.();
      return;
    }

    const viewport = root.querySelector('[data-valmonti-carousel-viewport]');
    const previous = root.querySelector('[data-valmonti-carousel-previous]');
    const next = root.querySelector('[data-valmonti-carousel-next]');
    if (!viewport || !previous || !next) return;

    root.dataset.valmontiCarouselReady = 'true';
    root.classList.add('is-ready');

    const update = () => {
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const hasOverflow = maximum > 2;
      root.classList.toggle('is-static', !hasOverflow);
      previous.disabled = !hasOverflow || viewport.scrollLeft <= 2;
      next.disabled = !hasOverflow || viewport.scrollLeft >= maximum - 2;
    };
    root.valmontiCarouselUpdate = update;

    const move = (direction) => {
      const firstItem = viewport.querySelector(':scope > [role="listitem"]');
      const styles = getComputedStyle(viewport);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = firstItem ? firstItem.getBoundingClientRect().width + gap : viewport.clientWidth;
      viewport.scrollBy({
        left: direction * distance,
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(viewport);
    update();
  };

  const observe = (scope = document) => scope.querySelectorAll('[data-valmonti-carousel]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('valmonti:carousel:refresh', (event) => observe(event.target));
})();
